module.exports = __webpack_public_path__ + "static/media/Delivery.780b7f1c.png";